<template>
<div > 
  <a class="btn"  @click="checkshow" v-if="showButton==true" > 
    <Tooltip placement="top-end" :always="true" style="position:fixed; right:20px;bottom: 70px;" :disabled="tipdisable">
      <img :src="require('@/assets/robot.png')" style="width:60px;height:60px" />
      <div slot="content">
            <p>Hi~我是小石</p>
            <p>可以問我問題喔!</p>
        </div>          
    </Tooltip>
    </a>     
 
  <router-link  
    :to="{path:'/login'}" 
    v-else>   
      <Tooltip placement="top-end" :always="true" style="position:fixed; right:20px;bottom: 70px;" :disabled="tipdisable">
      <img :src="require('@/assets/robot.png')"    
           style="width:60px;height:60px"  />  
           <div slot="content">
            <p>登入會員</p>
            <p>就能問小石問題喔!</p>
        </div>          
      </Tooltip>
  </router-link>
        
  <Modal           
           v-model="value3" 
           class-name="Footerbar-modal"
           scrollable
           :width="400"
           :mask-closable="false"  
                 
        >     
        <div v-if="value3">      
        <iframe ref="d8ai" src="https://prod.d8ai.ai/lc/#/D2qfLPT0JJw908NnMkAXO_TUsGw" frameborder="0" scrolling="no" allowtransparency="true" style="width: 0;height: 100%; min-width: 100%; min-height:500px;"  ></iframe>
        </div>        
          <div slot="footer" />
         </Modal> 
    </div>
</template>

<script>
  import { mapState} from 'vuex';
  import { Modal, Button, Tooltip } from "iview";
//import { Drawer } from "drawer";
  export default {   
    components: {  
    Button,
    //Drawer,
    Modal,    
    Tooltip
  },
    data()  {
      return {
        timer:null,
        time:10,
        tipdisable:false
      };
    },
    props: {
      value3: {
        type: Boolean,
        default: false
      },
  showButton: {  //20211222 Footerbar rollback //20211224 Wen Add 小石
        type: Boolean,
        default: true
      }
    },    
    computer :{     
      ...mapState({
        isLogin:({ user }) =>user.isLogin,
        loading: ({ user }) => user.loading,
      })
    },
    mounted() {   
      if (this.$store.state.user.isLogin==true|| this.$store.state.user.loading==true)
      {
        this.showButton=true; 
      }
      else{
        this.showButton=false;        
      }  
      this.timer=setInterval(this.tiptimeout,1000);
    },
    beforeDestroy(){
      clearInterval(this.timer);
    },
    methods: {   
      checkshow()
      {
        if (this.$store.state.user.isLogin==true)
        {
        this.value3=true;
        }
        else 
        {
          this.value3=false;
        } 
      },
      tiptimeout()
      {
        this.time --;
        if (this.time==0)
        {
          this.tipdisable=true;
          //console.log(125);
          clearInterval(this.timer);
        }
        //console.log("tipdisable"+this.tipdisable+";time"+ this.time);
      }
    }
  };
</script>